<template lang='pug'>
  header.l-header(
    :class='headerClass'
  )
    md-button.l-header__logo(
      @click='handleMove(logo.target)'
      :class='(currentSection === 1) ? "is-current" : ""'
    )
      h1.l-header__logo-wrap
        include logo_gift.pug
    md-button.l-header__menu(
      class='md-fab md-clean md-mini is-hide-min-md'
      @click.native='handleToggleMenu'
    )
      md-icon {{isOpen ? 'close' : 'menu'}}
    nav.l-header__nav
      md-list.l-header__list
        template(
          v-for='(item, index) in navItems'
        )
          md-list-item.l-header__item(
            v-show='index !== 0'
            :key='index'
            @click='handleMove(item.target)'
            :class='(currentSection === (index + 1)) ? "is-current" : ""'
          )
            span.l-header__label {{item.label}}
            md-icon.l-header__icon chevron_right
    div.l-header__sns
      .l-header__btn-facebook
        md-button.md-fab(
          href='https://www.facebook.com/SATOBUSSAN'
          target='_blank'
        )
          md-icon.fa.fa-facebook
      .l-header__btn-like
        iframe(
          src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2FSATOBUSSAN&width=250&layout=button_count&action=like&size=small&share=true&height=46&appId=834694026693662"
          width="180"
          height="50"
          style="border:none;overflow:hidden"
          scrolling="no"
          frameborder="0"
          allowfullscreen="true"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        )
</template>

<script>
export default {
  name: 'globalHeader',
  props: [
    'currentSection',
  ],
  data() {
    return {
      logo: {
        target: '#jsTargetTop',
      },
      navItems: [
        {
          label: 'トップ',
          target: '#jsTargetTop',
        },
        {
          label: '当店について',
          target: '#jsTargetAbout',
        },
        {
          label: 'おみやげ',
          target: '#jsTargetShop',
        },
        {
          label: '会社概要',
          target: '#jsTargetCompany',
        },
        {
          label: 'アクセス',
          target: '#jsTargetAccess',
        },
        {
          label: 'お問い合わせ',
          target: '#jsTargetContact',
        },
      ],
      isOpen: false,
    };
  },

  computed: {
    headerClass() {
      const self = this;
      const evenOdd = (self.currentSection % 2 !== 0) ? 'is-odd' : 'is-even';
      const openClose = self.isOpen ? ' is-open' : ' ';
      return evenOdd + openClose;
    },
  },

  mounted() {
  },

  methods: {
    handleMove(target) {
      this._.throttle(() => {
        this.jump(target, {
          duration: 500,
          offset: 0,
        });
      }, 500)();
    },

    handleToggleMenu() {
      const self = this;
      self.isOpen = !self.isOpen;
    },
  },
};
</script>



// WEBPACK FOOTER //
// header.vue?53f96347